import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { BiSolidArchiveIn, BiSolidArchiveOut } from 'react-icons/bi';
import { archiveOrders, orders } from '../../../Services/AdminServices/AdminCommissionServices';
import DataTables from '../../Main/DataTable/DataTables';

const Orders = () => {

    const [data, setData] = useState([]);
    const [archiveData, setArchiveData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isArchive, setIsArchive] = useState(false);

    const columns = [
        { name: 'Referal User', selector: row => row.user_referrer?.email },
        { name: 'Referal Code', selector: row => row.referrer_referral_code },
        { name: 'Order Id', selector: row => row.shopify_order_id },
        { name: 'Shopify User Email', selector: row => row.contact_email },
        { name: 'Total Price', selector: row => row.total_price },
        { name: 'Discount Price', selector: row => row.total_discounts },
        { name: 'Status', selector: row => row.status },
    ];
    const archiveColumns = [
        { name: 'Referal User', selector: row => row.user_referrer?.email },
        { name: 'Referal Code', selector: row => row.referrer_referral_code },
        { name: 'Order Id', selector: row => row.shopify_order_id },
        { name: 'Shopify User Email', selector: row => row.contact_email },
        { name: 'Total Price', selector: row => row.total_price },
        { name: 'Discount Price', selector: row => row.total_discounts },
        { name: 'Deleted At', selector: row => row.deleted_at },
    ];

    const getOrders = async () => {
        setLoading(true)
        const response = await orders();
        if (response?.code === 200) {
            setData(response?.result?.sh_orders?.original?.data)
            setLoading(false)
        }
    }

    const getArchiveOrders = async () => {
        setLoading(true)
        const response = await archiveOrders();
        if (response?.code === 200) {
            setArchiveData(response?.result?.sh_orders?.original?.data)
            setLoading(false)
        }
    }

    useEffect(() => { getOrders(); getArchiveOrders(); }, [])

    return (


        <>
            <div className="container">
                <div className="row">
                    <div className="col-lg">
                        <h3 className='fw-bold mb-0'>Shopify Orders</h3>
                        <p className='text-muted'>Manage shopify orders </p>
                    </div>

                    <div className="col-auto">
                        <Button onClick={() => { setIsArchive(!isArchive) }}>
                            {
                                isArchive ?
                                    <BiSolidArchiveIn size={22} />
                                    :
                                    <BiSolidArchiveOut size={22} />
                            }
                            {/* Archive Orders {" "} */}
                        </Button>
                    </div>


                    {isArchive ? (
                        <>
                            {loading ? (
                                <div style={{ textAlign: 'center', padding: '50px' }}>
                                    <div className="spinner-border text-info" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ) : (
                                <div className="col-lg-12">
                                    <DataTables filter={true} columns={archiveColumns} data={archiveData} />
                                </div>
                            )}
                        </>
                    ) :
                        (
                            <>
                                {loading ? (
                                    <div style={{ textAlign: 'center', padding: '50px' }}>
                                        <div className="spinner-border text-info" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="col-lg-12">
                                        <DataTables filter={true} columns={columns} data={data} />
                                    </div>
                                )}
                            </>
                        )}



                </div>
            </div>
        </>
    )
}

export default Orders